import React from "react";

import Typography from "@material-ui/core/Typography";

import { useStyles } from "./input-page-styles";
import Questions from "./questions";

export default () => {
  const classes = useStyles();

  return (
    <main>
      <Typography className={classes.header} component="h1" variant="h5">
        Калькулятор Вашего
        <br />
        капитала на 20 лет
        <span role="img" aria-label="calculator">
          {" "}
          📈
        </span>
      </Typography>
      <Questions />
    </main>
  );
};
